import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, List, ListItem, Typography } from "@mui/material";
import { fontColor } from "../../../constants/ColorSets";
import { getMyRoleBundles, getRoleBundles } from "../../../redux/actions/Role";
import { RoleBundle } from "../../../types/models/RoleBundle";

const ActiveRoleBundle = () => {
  const dispatch = useDispatch();

  const [activeRoleBundles, setActiveRoleBundles] = useState<RoleBundle[] | undefined>(undefined);
  
  useEffect(() => {
    dispatch(
      getRoleBundles((bundles) =>
        dispatch(
          getMyRoleBundles((myRoleBundles) => {
            const myRoleBundleIds = myRoleBundles?.map(bundle => bundle.RoleBundleId) ?? [];
            const roleBundles = bundles.filter(bundle => myRoleBundleIds.includes(bundle.Id));
            setActiveRoleBundles(roleBundles);
          })
        )
      )
    );
  }, []);

  return (
    <Box sx={{ py: 1, pl: "18px", pr: "20px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ color: fontColor.titleFontColor, alignContent: "center" }}>{"Active Role Bundles (" + (activeRoleBundles?.length ?? 0) + ")"}</Typography>
      </Box>
      <Box sx={{ border: "1px solid " + fontColor.grayBackground }}>
        {(activeRoleBundles?.length ?? 0) > 0 ? (
          <List>
            {activeRoleBundles?.map((activeRoleBundle, index) => (
              <ListItem
                key={activeRoleBundle.Id}
                sx={{
                  borderBottom: index !== (activeRoleBundles?.length ?? 0) - 1 ? "1px solid " + fontColor.grayBackground : "none",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  {activeRoleBundle.DisplayName}
                </Box>
              </ListItem>
            ))}
          </List>
        ) : (
          <Box
            sx={{
              display: "grid",
              background: fontColor.ruleSearchEmptyResultBackground,
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              textAlign: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <Box sx={{ margin: 1, color: "grey" }}>No role bundles assigned</Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ActiveRoleBundle;
